import { render, staticRenderFns } from "./StcvPL.vue?vue&type=template&id=60748318"
import script from "./StcvPL.vue?vue&type=script&lang=js"
export * from "./StcvPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports